class exports.ZonesHandler extends Handler

    init: () ->
        @layoutUrl = 'backend/portal/zones/load-layout'
        @layoutSelector = App.sidebar.contentDiv()

        @subHandlers =
            'Zones':
                'class': 'portal::handlers/zones/ZonesDialogHandler'

        @defaultSub = 'Zones'

        @loadLayout()


    afterLoadLayout: (selector, response) ->
        if response.status?.type isnt 'success'
            return

        self = this
        layout = $(@layoutSelector)

        handler = @createSubHandler(@defaultSub)
        if handler
            handler.init()
        else
            throw new Error("#{@defaultSub} is not a valid subhandler")

        # Placement Program dropdowns
        layout.find('.sel-pp').on 'change', () ->
            layout.find('.sel-pp').not(this).val($(this).val())
            self.refreshSubHandlers()

        layout.find('.nav-tabs [href="#zones"]').on 'click', () ->
            layout.find('#sel_sz_pp').trigger('change')

        # Add Zone button
        layout.find('#btn_add_zone').on 'click', () =>
            for k, v of @activeSubHandlers
                v.addEditZone?()
